import {PayloadAction, Reducer} from "@reduxjs/toolkit"
import {Order, PaperOrderDetails} from "../../shared/entities/Order/Order";
import {SendMailResponse} from "../../shared/Mail/SendMailResponse";

export type OrderState = {
    orderList: Array<Order> | []
    order: Order | null
    paperOrder: PaperOrderDetails | null
    invoiceFile: Blob
    orderCheckout?: Order
    sendMailResponse: SendMailResponse | null
    orderClientList: { orders: Array<Order>, count: number }
}

const State: OrderState = {
    orderList: [],
    order: null,
    paperOrder: null,
    sendMailResponse: null,
    invoiceFile: new Blob(),
    orderCheckout: undefined,
    orderClientList: {
        orders: [],
        count: 0
    }
}

export enum ActionTypes {
    ORDER = "ORDER",
    PAPER_ORDER = "PAPER_ORDER",
    INVOICE_PDF = "INVOICE_PDF",
    ORDER_LIST = "ORDER_LIST",
    ORDER_CHECKOUT = "ORDER_CHECKOUT",
    GET_ORDER_LIST = "GET_ORDER_LIST",
    SEND_INVOICE = "SEND_INVOICE",
    PRINT_PRESSED = "PRINT_PRESSED",
    CLEAR_PAPER_ORDER = "CLEAR_PAPER_ORDER"
}

export const OrderReducer: Reducer<OrderState, PayloadAction<any>> = (state = State, action: PayloadAction<any>): OrderState => {
    switch (action.type) {
        case ActionTypes.ORDER:
            return state = {
                ...state,
                order: action.payload,
            }
        case ActionTypes.PAPER_ORDER:
            return state = {
                ...state,
                paperOrder: action.payload,
            }
        case ActionTypes.CLEAR_PAPER_ORDER: // Новый case
            return {
                ...state,
                paperOrder: null,
            }
        case ActionTypes.ORDER_LIST:
            return state = {
                ...state,
                orderList: action.payload,
            }
        case ActionTypes.GET_ORDER_LIST:
            return state = {
                ...state,
                orderClientList: action.payload
            }
        case ActionTypes.ORDER_CHECKOUT:
            return state = {
                ...state,
                orderCheckout: action.payload
            }
        case ActionTypes.INVOICE_PDF:
            return state = {
                ...state,
                invoiceFile: action.payload,
            }
        case ActionTypes.SEND_INVOICE:
            return state = {
                ...state,
                sendMailResponse: action.payload,
            }
        default:
            return state
    }
}

